// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-device-configuration-container{
    position: absolute;
    top: 20px;
    right: 20%;
    width: 100%;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    border-radius: 10px;
}
.new-device-configuration-header{
    margin: 0px;
    padding: 15px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
    box-sizing: border-box;
}
.new-device-configuration-header h3{
    margin: 0px;
    color: white;
    font-weight: lighter;
}
.new-device-configuration-header p{
    margin: 0px;
    color: white;
    font-size: 20px;
    cursor: pointer;
}
.new-device-configuration-body{
    padding-top: 20px;
}
.new-device-configuration-device-details-container{
    margin: 15px;
    padding: 10px 15px;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.new-device-configuration-device-details-container h5{
    margin: 0px;
    margin-bottom: 10px;
}
.new-device-configuration-title-input-container,
.new-device-configuration-type-input-container{
    width: 30%;
    padding-top: 2px;
    margin-left: 20px;
    margin-bottom: 10px;
    border-radius: 10px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
}
.new-device-configuration-title-input-container p,
.new-device-configuration-type-input-container p{
    margin: 0px;
    margin-top: 4px;
    margin-left: 10px;
    font-size: 12px;
    font-weight: 600;
}
.new-device-configuration-title-input-container input{
    border: none;
    outline: none;
    padding: 4px 10px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 0px 0px 10px 10px;
}
.new-device-configuration-type-input-container select{
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    margin: 0px;
    background-color: transparent;
}
.new-configuration-details-device-parameters{
    margin: 15px;
    padding: 10px 15px;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.new-configuration-details-table-container{
    overflow: auto;
    height: 30vh;
}
.new-configuration-details-table-header{
    margin: 0px;
}
.new-configuration-details-table{
    width: 100%;
}
.new-configuration-details-table-default-value-th{
    display: flex;
    justify-content: space-around;
}
.new-configuration-details-table{
    border-collapse: collapse;
}
.new-configuration-details-table th, .new-configuration-details-table td{
    text-align: left;
}
#header-row{
    background-color: white;
}
.new-configuration-details-table td input{
    width: 80%;
    padding: 4px 6px;
    margin: 2px 0px;
    outline: none;
    border: none;
    background-color: transparent;
}
.new-configuration-details-table tr:nth-child(odd){
    background-color: rgba(206, 206, 206, 0.952);
}
.new-configuration-details-table tr:nth-child(even){
    background-color: rgb(242, 242, 242);
}
.new-configuration-details-table td button{
    padding: 0px 12px;
    border: none;
    cursor: pointer;
    background-color: transparent;
}
.new-configuration-details-table td img{
    height: 20px;
}
.new-device-configuration-buttons-container{
    padding: 5px 30px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
.new-device-configuration-buttons-container button{
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 10px;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
}



.new-device-configuration-message-box-container{
    position: absolute;
    top: 40%;
    left: 28%;
    width: 25vw;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.new-device-configuration-message-box-title-container{
    display: flex;
    margin-bottom: 5px;
    justify-content: space-between;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-device-configuration-message-box-title-container p{
    margin: 4px 14px;
    color: white;
}
.new-device-configuration-message-box-message-container{
    width: 100%;
    display: flex;
    justify-content: center;
}
.new-device-configuration-message-box-message-container p{
    margin: 20px;
    margin-left: 25px;
}
.new-device-configuration-message-box-buttons-container{
    text-align: right;
}
.new-device-configuration-message-box-buttons-container button{
    color: white;
    border: none;
    margin: 10px;
    cursor: pointer;
    border-radius: 5px;
    padding: 4px 20px;
    margin-right: 15px;
    margin-top: 5px;
    background-color: rgba(155, 30, 30, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Devices/NewConfiguration.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,0CAA0C;IAC1C,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;;IAEI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;AAC1C;AACA;;IAEI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;AAC9C;;;;AAIA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0CAA0C;AAC9C","sourcesContent":[".new-device-configuration-container{\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20%;\r\n    width: 100%;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n    border-radius: 10px;\r\n}\r\n.new-device-configuration-header{\r\n    margin: 0px;\r\n    padding: 15px;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-sizing: border-box;\r\n}\r\n.new-device-configuration-header h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-weight: lighter;\r\n}\r\n.new-device-configuration-header p{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n.new-device-configuration-body{\r\n    padding-top: 20px;\r\n}\r\n.new-device-configuration-device-details-container{\r\n    margin: 15px;\r\n    padding: 10px 15px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-device-configuration-device-details-container h5{\r\n    margin: 0px;\r\n    margin-bottom: 10px;\r\n}\r\n.new-device-configuration-title-input-container,\r\n.new-device-configuration-type-input-container{\r\n    width: 30%;\r\n    padding-top: 2px;\r\n    margin-left: 20px;\r\n    margin-bottom: 10px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-device-configuration-title-input-container p,\r\n.new-device-configuration-type-input-container p{\r\n    margin: 0px;\r\n    margin-top: 4px;\r\n    margin-left: 10px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n}\r\n.new-device-configuration-title-input-container input{\r\n    border: none;\r\n    outline: none;\r\n    padding: 4px 10px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    border-radius: 0px 0px 10px 10px;\r\n}\r\n.new-device-configuration-type-input-container select{\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    padding: 5px;\r\n    margin: 0px;\r\n    background-color: transparent;\r\n}\r\n.new-configuration-details-device-parameters{\r\n    margin: 15px;\r\n    padding: 10px 15px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-configuration-details-table-container{\r\n    overflow: auto;\r\n    height: 30vh;\r\n}\r\n.new-configuration-details-table-header{\r\n    margin: 0px;\r\n}\r\n.new-configuration-details-table{\r\n    width: 100%;\r\n}\r\n.new-configuration-details-table-default-value-th{\r\n    display: flex;\r\n    justify-content: space-around;\r\n}\r\n.new-configuration-details-table{\r\n    border-collapse: collapse;\r\n}\r\n.new-configuration-details-table th, .new-configuration-details-table td{\r\n    text-align: left;\r\n}\r\n#header-row{\r\n    background-color: white;\r\n}\r\n.new-configuration-details-table td input{\r\n    width: 80%;\r\n    padding: 4px 6px;\r\n    margin: 2px 0px;\r\n    outline: none;\r\n    border: none;\r\n    background-color: transparent;\r\n}\r\n.new-configuration-details-table tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206, 0.952);\r\n}\r\n.new-configuration-details-table tr:nth-child(even){\r\n    background-color: rgb(242, 242, 242);\r\n}\r\n.new-configuration-details-table td button{\r\n    padding: 0px 12px;\r\n    border: none;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n}\r\n.new-configuration-details-table td img{\r\n    height: 20px;\r\n}\r\n.new-device-configuration-buttons-container{\r\n    padding: 5px 30px;\r\n    padding-bottom: 20px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.new-device-configuration-buttons-container button{\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 20px;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n\r\n\r\n\r\n.new-device-configuration-message-box-container{\r\n    position: absolute;\r\n    top: 40%;\r\n    left: 28%;\r\n    width: 25vw;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.new-device-configuration-message-box-title-container{\r\n    display: flex;\r\n    margin-bottom: 5px;\r\n    justify-content: space-between;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-device-configuration-message-box-title-container p{\r\n    margin: 4px 14px;\r\n    color: white;\r\n}\r\n.new-device-configuration-message-box-message-container{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.new-device-configuration-message-box-message-container p{\r\n    margin: 20px;\r\n    margin-left: 25px;\r\n}\r\n.new-device-configuration-message-box-buttons-container{\r\n    text-align: right;\r\n}\r\n.new-device-configuration-message-box-buttons-container button{\r\n    color: white;\r\n    border: none;\r\n    margin: 10px;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    padding: 4px 20px;\r\n    margin-right: 15px;\r\n    margin-top: 5px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
